import { stringLookup, zLookup } from '@/utils/zodHelper';
import { z } from 'zod';

const ProductionPhaseTranslationSchema = z.object({
  id: z.number().optional(),
  name: z.string().max(200),
  language_code: stringLookup(),
  inlineIndex: z.number().optional(),
});

export const ProductionPhaseSchema = z.object({
  id: z.number().optional(),
  order: z.number().default(0).optional(),
  translations: z.array(ProductionPhaseTranslationSchema).optional(),
  unit: zLookup(),
  division: zLookup().optional(),
  is_active: z.boolean().optional(),
});

export type ProductionPhaseSchemaType = z.infer<typeof ProductionPhaseSchema>;
